export const intervalToMilliseconds = (interval) => {
  const unit = interval.slice(-1).toUpperCase(); // Get the last character (unit)
  const value = parseInt(interval.slice(0, -1)); // Get the numeric part of the string

  switch (unit) {
    case 'S': // Seconds
      return value * 1000;
    case 'M': // Minutes
      return value * 60 * 1000;
    case 'H': // Hours
      return value * 60 * 60 * 1000;
    case 'D': // Days
      return value * 24 * 60 * 60 * 1000;
    default:
      throw new Error('Invalid interval format');
  }
}



export const formatTimestampInMs = (timestampInMilliseconds) => {

  // Create a Date object
  const date = new Date(timestampInMilliseconds);

  // Extract year, month, day, hours, minutes, and seconds
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format the date and time into the desired string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
